<template>
  <figure class="figure">
    <img
      :src="src"
      alt=""
      draggable="false"
      width="79"
      height="79"
    />
  </figure>
</template>

<script>
export default {
  name: 'ChatIcon',
  props: {
    src: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.figure {
 display: inline-block;

  @media (max-width: 767px) {
    margin-top: 8px;
  }
}
</style>
